import { render, staticRenderFns } from "./FeedbackForm.vue?vue&type=template&id=2d820b49&scoped=true"
import script from "./FeedbackForm.vue?vue&type=script&lang=js"
export * from "./FeedbackForm.vue?vue&type=script&lang=js"
import style0 from "./FeedbackForm.vue?vue&type=style&index=0&id=2d820b49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d820b49",
  null
  
)

export default component.exports